import { render, staticRenderFns } from "./StrategySection.vue?vue&type=template&id=dd3095ec&scoped=true"
import script from "./StrategySection.vue?vue&type=script&lang=js"
export * from "./StrategySection.vue?vue&type=script&lang=js"
import style0 from "./StrategySection.vue?vue&type=style&index=0&id=dd3095ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3095ec",
  null
  
)

export default component.exports